import styled from "styled-components";

export const BlockContentStyle = styled.div`
  max-width: 800px;
  & > p {
    margin: 0;
    & + p {
      margin-top: 1em;
    }
  }
`;
